module.exports = __webpack_public_path__ + "media/media/values/executive-vice-president-9c94d7f16e38a67ca792d33d5bd8a1d6.jpg";